<template>
  <div class="header">
    <div class="menu">
      <b-navbar toggleable="lg" type="light">
        <b-navbar-brand href="#">
          <img alt="Vue logo" id="logo" src="../assets/logo.png">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav id="navbars">
              <b-nav-item to="/home" class="li">Home</b-nav-item>
              <b-nav-item to="/espaco" class="li">Espaço</b-nav-item>
              <b-nav-item-dropdown text="Cursos" class="li">
                <b-dropdown-item to="/cursos" class="li">Extensivos</b-dropdown-item>
                <b-dropdown-item to="/modulares" class="li">Modulares</b-dropdown-item>
                <!-- <b-dropdown-item to="/cursos-sjc" class="li">Extensivos SJC</b-dropdown-item> -->
              </b-nav-item-dropdown>
              <b-nav-item to="/material" class="li">Materiais</b-nav-item>
              <b-nav-item to="/galeria" class="li">Galeria</b-nav-item>
              <b-nav-item to="/aprovados" class="li">Aprovados</b-nav-item>
              <b-nav-item to="/projetos" class="li">Projetos</b-nav-item>
              <b-nav-item to="/tecnologias" class="li">Tecnologias</b-nav-item>
              <b-nav-item to="/contato" class="li">Contato</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
<!-- Google Tag Manager -->
<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-T5S2CFJ');</script>
<!-- End Google Tag Manager -->

<style media="screen">
@import "../assets/style_padrao.css";
  #logo{
    width:80%;
    padding-left:1%;
  }
  .menu{
    box-shadow: 3px 1px #DCDCDC;
    background: white!important;
  }
  #navbars{
    width: 100%;
    display:flex;
    justify-content: flex-end;
    cursor:pointer;
  }
  .navbar-light .navbar-nav .nav-link:hover{
    color:rgba(0, 0, 0, 0.5);
  }
  .li{
    /* justify-content: flex-end; */
    width: 100%;
    font-size: 17px;
    text-decoration: none;
    color: #7435af!important;
  }
  .li:link{
    text-decoration:none;
  }
  .navbar-light .navbar-nav .nav-link {
    color: #7435af!important;
  }
</style>
